require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./forecasting-street-robberies.json") })
        }
      }, "path---forecasting-street-robberies");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---forecasting-street-robberies!./.cache/json/forecasting-street-robberies.json
// module id = 895
// module chunks = 231608221292675